/***
 *
 *   TICKET LIST VIEW STYLES
 *   Cell treatments for the list alternative to the kanban board — the table
 *   chrome itself lives in components/table/dataTable.tailwind.js.
 *
 **********/

const Style = {
    number: 'font-mono text-xs text-text-muted',
    subject: 'line-clamp-1 font-medium text-text-primary',
    secondary: 'text-sm text-text-secondary',
    muted: 'text-sm text-text-muted',

    due: 'flex items-center gap-1 whitespace-nowrap text-sm',
    dueOverdue: 'font-semibold text-error',
    dueNormal: 'text-text-secondary',

    empty: 'min-h-0 flex-1 border-none bg-transparent',

    // mobile card
    cardTop: 'mb-1 flex items-center justify-between gap-2',
    cardSubject: 'mb-2 text-sm font-medium text-text-primary',
    cardMeta: 'flex items-center justify-between gap-2',
    cardFooter:
        'mt-2 flex items-center justify-between gap-2 border-t border-border pt-2 text-xs text-text-muted',
    cardFooterRight: 'flex items-center gap-3',
    cardComments: 'flex items-center gap-1',
};

export default Style;
